// Things that are being re-used between apps

export let title = (str) => `${str} | Medon`;
export let store = null;
export let setSharedStore = (s) => {
    store = s;
}